import React from 'react';
import Divider from '@material-ui/core/Divider';
import { CustomDividerWrapper } from './RoDivider.styles';

type Props = {};

const RoDivider = (props: Props) => (
  <CustomDividerWrapper {...props}>
    <Divider />
  </CustomDividerWrapper>
);
RoDivider.defaultProps = {
  offset: 0
};
export default RoDivider;
